import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    // 悟空图像
    {
      path: '/',
      name: 'layout',
      component: () => import('@/views/layout'),
      redirect: '/PhotoSir',
      children: [
        // 悟空图像
        {
          path: '/PhotoSir',
          name: 'PhotoSir',
          component: () => import('@/views/PhotoSir')
        },
        // 企业新闻
        {
          path: '/CompanyNews',
          name: 'CompanyNews',
          component: () => import('@/views/CompanyNews')
        },
        // 企业新闻详情
        {
          path: '/CompanyNewsDetails',
          name: 'CompanyNewsDetails',
          component: () => import('@/views/CompanyNewsDetails')
        },
        // 视频教程
        {
          path: '/VideoTutorial',
          name: 'VideoTutorial',
          component: () => import('@/views/VideoTutorial')
        },
        // 视频教程详情
        {
          path: '/VideosDetails',
          name: 'VideosDetails',
          component: () => import('@/views/VideosDetails')
        },
        // 下载
        {
          path: '/Download',
          name: 'Download',
          component: () => import('@/views/Download')
        },
        // 购买
        {
          path: '/AiFlashPaint',
          name: 'AiFlashPaint',
          component: () => import('@/views/AiFlashPaint')
        },
        // 购买
        {
          path: '/Store',
          name: 'Store',
          component: () => import('@/views/Buy')
        },
        {
          path: '/Buy',
          name: 'Buy',
          component: () => import('@/views/Buy')
        },

      ]
    },
    {
      path: '/VipPc',
      name: 'VipPc',
      component: () => import('@/views/svip_pc')
    },
    {
      path: '/VipPad',
      name: 'VipPad',
      component: () => import('@/views/svip_pad')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js